module.exports = __webpack_public_path__ + "static/img/personnote_img_avatar3.7b025ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personnote_img_avatar3.png
// module id = UF20
// module chunks = 0